import { textAtomTypeId } from '@/enums';
import { useSceneTextSave } from './useSceneTextSave';

export function useUpdateSceneLogline() {
    return useSceneTextSave({ action: 'updateLogline', typeId: textAtomTypeId.scene_logline });
}
